import { render, staticRenderFns } from "./create-or-edit-jump-protocol.vue?vue&type=template&id=3c7ca972&scoped=true"
import script from "./create-or-edit-jump-protocol.vue?vue&type=script&lang=js"
export * from "./create-or-edit-jump-protocol.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3c7ca972",
  null
  
)

export default component.exports